import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from './config/supabaseClient';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getSession = async () => {
      const { data } = await supabase.auth.getSession();
      setUser(data.session?.user ?? null);
      setLoading(false);
    };
    getSession();

    const { data: listener } = supabase.auth.onAuthStateChange(async (_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  // Function to refresh token if needed
  const refreshTokenIfNeeded = async () => {
    try {
      const { data: sessionData } = await supabase.auth.getSession();
      if (!sessionData.session) {
        console.log('No active session, attempting refresh...');
        const { data: refreshData, error } = await supabase.auth.refreshSession();
        if (!error && refreshData.session) {
          setUser(refreshData.session.user);
          console.log('Token refreshed successfully');
          return refreshData.session.access_token;
        } else {
          console.log('Token refresh failed');
          setUser(null);
          return null;
        }
      }
      return sessionData.session?.access_token;
    } catch (error) {
      console.error('Token refresh error:', error);
      setUser(null);
      return null;
    }
  };

  const signInWithGoogle = async (redirectPath = '/dashboard') => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin + redirectPath
      }
    });
    if (error) console.error('Error signing in:', error);
  };

  const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) console.error('Error signing out:', error);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signInWithGoogle, signOut, refreshTokenIfNeeded }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}